/* import __COLOCATED_TEMPLATE__ from './no-longer-stale.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { APPLICATION } from 'sh-www/models/application';
import { closeModal } from 'sh-www/utils/modal-controls';

class ProjectNoLongerStaleModalComponent extends Component {
  @service session;

  get modalHeader() {
    const { status } = this.args.model.application;
    switch (status) {
      case APPLICATION.STATUS.CANCELLED:
        return 'Project canceled';
      case APPLICATION.STATUS.ACTIVE:
        return 'Project marked active';
      default:
        return 'Project no longer stale';
    }
  }

  get modalDescription() {
    const {
      buyer,
      seller,
      status,
    } = this.args.model.application;

    let prefix = '';
    switch (status) {
      case APPLICATION.STATUS.CANCELLED:
        prefix = 'This project has already been canceled.';
      case APPLICATION.STATUS.ACTIVE:
        prefix = 'Project marked active.';
      default:
        prefix = 'Project no longer stale.';
    }

    const otherParty = this.session.currentUser.isSeller
      ? buyer.fullName
      : seller.fullName;

    return `${prefix} You can view more information on the project page or reach out to ${otherParty} if you think there has been a mistake.`
  }

  @action
  handleClose() {
    closeModal(this);
  }
}

export default ProjectNoLongerStaleModalComponent;
